export function isPaperInboxLive(): boolean {
    return process.env.EXPO_PUBLIC_PAPER_INBOX_LIVE === 'true';
}
